// removed by extract-text-webpack-plugin
module.exports = {"panel":"panel___1WbzA","header":"header___1bwqQ","arrow":"arrow___2_qvo","print-header":"print-header___2ohgJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Panels/Panel.scss
// module id = qNQ/
// module chunks = 46